import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../../requests';

type UseDeleteVirtualPortfolioItemOptions = {
  onReject?: UseMutationConfig<object>['onReject'];
  onSuccess?: UseMutationConfig<object>['onSuccess'];
};

export default function useDeleteVirtualPortfolioItemQuery({
  onReject,
  onSuccess,
}: UseDeleteVirtualPortfolioItemOptions) {
  const {
    execute: deleteVirtualPortfolioItem,
    isPending: isLoadingDeleteVirtualPortfolioItem,
    ...query
  } = useMutation<string>(
    ({ id }: { id: number }) => API.deleteVirtualPortfolio(id),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    deleteVirtualPortfolioItem,
    isLoadingDeleteVirtualPortfolioItem,
    ...query,
  };
}
